module.exports = require("@pb/kit-component-message");